import SunsetBannerTemplate from '../../template/sunset-banner.html';

class SunsetBannerController {
    constructor($pfUser, $pfFeatures, $scope, PF_FEATURE_SWITCHES) {
        this.$pfUser = $pfUser;
        this.$pfFeatures = $pfFeatures;
        this.$scope = $scope;
        this.PF_FEATURE_SWITCHES = PF_FEATURE_SWITCHES;

        this.isBannerVisible = false;
        this.communityUrl = 'https://community.instructure.com/en/kb/articles/664337-how-do-i-export-my-canvas-student-eportfolio-into-a-zip-file';

        this.initialize();
    }

    async initialize() {
        const currentUser = this.$pfUser.getUser();
        if (currentUser) {
            try {
                // Check if feature flag is initialized, if not, initialize it
                if (!this.$pfFeatures.isInited) {
                    await this.$pfFeatures.init();
                }

                // Only show banner if feature flag is enabled
                this.isBannerVisible = this.$pfFeatures.isOn(this.PF_FEATURE_SWITCHES.SUNSET_BANNER);

                // Trigger digest cycle to update the view
                this.$scope.$applyAsync();
            } catch (error) {
                console.error('Error checking sunset banner feature flag:', error);
                // Default to not showing the banner on error
                this.isBannerVisible = false;
            }
        }
    }
}

SunsetBannerController.$inject = [
    '$pfUser',
    '$pfFeatures',
    '$scope',
    'PF_FEATURE_SWITCHES',
];

function sunsetBannerDirective() {
    return {
        controller: SunsetBannerController,
        controllerAs: 'sunsetCtrl',
        template: SunsetBannerTemplate,
    };
}

export default sunsetBannerDirective;
